import styled from "styled-components";
import { Checkbox as AntCheckbox } from "antd";

const Checkbox = styled(AntCheckbox)`
    .ant-checkbox-checked > .ant-checkbox-inner {
        background-color: ${({ theme: { colors } }) => colors.primary};
    }
    .ant-checkbox-inner {
        border-color: ${({ theme: { colors } }) => colors.primary} !important;
        height: 22px;
        width: 22px;
        border-radius: 6px;
    }
    .ant-checkbox-inner:after {
        height: 13px;
        width: 8px;
    }

    &.ant-checkbox-wrapper {
        span.ant-checkbox-checked::after {
            border: none;
        }
    }
`;

export default Checkbox;
